<template>
    <div class="paging">
        <a
            href="javascript:void(0)"
            class="paging__prev"
            @click="goToPage(currentPage - 1)"
            :class="{ 'disabled': currentPage === 1 }"
        >
            <i class="fa-solid fa-chevron-left"></i>
        </a>
        <div class="paging__inner">
            <a
                href="javascript:void(0)"
                v-for="page in visiblePages"
                :key="page"
                :class="{ 'paging__page_current': currentPage === page }"
                class="paging__page"
            >
                {{ page }}
            </a>
        </div>
        <a
            href="javascript:void(0)"
            class="paging__next"
            @click="goToPage(currentPage + 1)"
            :class="{ 'disabled': currentPage === lastPage }"
        >
            <i class="fa-solid fa-chevron-right"></i>
        </a>
    </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
    name: "Pagination",
    emits: ['changePage'],
    props: {
        lastPage: {
            type: Number | String,
            required: true
        },
        currentPage: {
            type: Number | String,
            required: true
        }
    },

    computed: {
        visiblePages() {
            const range = 3;
            const start = Math.max(1, this.currentPage - range);
            const end = Math.min(this.lastPage, this.currentPage + range);

            const pages = [];
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
    },
    methods: {
        goToPage(page) {
            if (page >= 1 && page <= this.lastPage && page !== this.currentPage) {
                this.$emit('changePage', page);
            }
        },
    },
})
</script>


<style scoped>

</style>
